/**
 * Typed access to the public build-time configuration.
 *
 * Vite inlines `import.meta.env` at build time, so this module is the single
 * place that reads it — everything else imports `env`.
 */
export const env = {
  /** Base URL of the Laravel API. Relative by default so the dev proxy works. */
  apiUrl: import.meta.env.VITE_API_URL ?? '/api',
  /** Public origin, used for canonical URLs, OG tags and the sitemap. */
  appUrl: import.meta.env.VITE_APP_URL ?? 'http://localhost:3000',
  /** The public site's canonical origin (SEO, and telling our hosts from a master's own). */
  siteUrl: import.meta.env.VITE_SITE_URL ?? 'https://krasahub.beauty',
  isProduction: import.meta.env.PROD,
  /**
   * Serve the mock API in the browser. Used by `npm run dev` with no backend
   * running, and by the preview build the visual gate screenshots, so the
   * pixels do not depend on what a live database happens to hold.
   */
  enableMocks: import.meta.env.VITE_ENABLE_MOCKS === 'true',
  /**
   * Comma-separated locales to serve, e.g. "uk" or "uk,ru,en". Launch ships uk
   * only; the other locales stay in the repository and are switched on here,
   * not by deleting or restoring files. Parsed in shared/config/locales.
   */
  enabledLocales: import.meta.env.VITE_ENABLED_LOCALES ?? 'uk',
  /**
   * paddle | freemius | none — must match the API's BILLING_PROVIDER. Only the
   * public pricing page reads it, because it renders without a session; inside
   * the dashboard GET /master/billing is the authority.
   */
  billingEnabled: ['paddle', 'freemius'].includes(import.meta.env.VITE_BILLING_PROVIDER ?? 'none'),
  /**
   * Map tiles for the catalogue map. OpenStreetMap's own servers by default,
   * which their tile policy allows for light use; point this at a tile
   * provider before traffic grows (DEPLOY_CHECKLIST).
   */
  mapTileUrl: import.meta.env.VITE_MAP_TILE_URL ?? 'https://tile.openstreetmap.org/{z}/{x}/{y}.png',
} as const;
